<template>
  <div id="app" class="fixed inset-0 overflow-hidden flex flex-col">
    <div class="flex-1 overflow-hidden">
      <router-view id="router-view" class="h-full flex flex-col" />
    </div>
    <nav
      id="navigation"
      v-if="$store.state.currentUser != null"
      class="border-t border-gray-200 shadow-inner flex items-center justify-around"
    >
      <router-link replace class="w-1/3 px-2 py-3" to="/">
        <svg
          class="mx-auto h-6 w-6 stroke-current text-gray-800"
          :class="{ 'text-primary-orange': $router.currentRoute.name != 'settings' }"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.75"
          viewBox="0 0 24 24"
        >
          <path
            :class="{ 'nav-icon-selected': $router.currentRoute.name != 'settings' }"
            d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"
          />
          <path d="M9 22V12h6v10" />
        </svg>
      </router-link>
      <router-link replace class="w-1/3 px-2 py-4" to="/settings">
        <svg
          class="mx-auto h-6 w-6 stroke-current text-gray-800"
          :class="{ 'text-primary-orange': $router.currentRoute.name == 'settings' }"
          fill="none"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.75"
          viewBox="0 0 24 24"
        >
          <path
            :class="{ 'nav-icon-selected': $router.currentRoute.name == 'settings' }"
            d="M19.4 15a1.65 1.65 0 00.33 1.82l.06.06a2 2 0 010 2.83 2 2 0 01-2.83 0l-.06-.06a1.65 1.65 0 00-1.82-.33 1.65 1.65 0 00-1 1.51V21a2 2 0 01-2 2 2 2 0 01-2-2v-.09A1.65 1.65 0 009 19.4a1.65 1.65 0 00-1.82.33l-.06.06a2 2 0 01-2.83 0 2 2 0 010-2.83l.06-.06a1.65 1.65 0 00.33-1.82 1.65 1.65 0 00-1.51-1H3a2 2 0 01-2-2 2 2 0 012-2h.09A1.65 1.65 0 004.6 9a1.65 1.65 0 00-.33-1.82l-.06-.06a2 2 0 010-2.83 2 2 0 012.83 0l.06.06a1.65 1.65 0 001.82.33H9a1.65 1.65 0 001-1.51V3a2 2 0 012-2 2 2 0 012 2v.09a1.65 1.65 0 001 1.51 1.65 1.65 0 001.82-.33l.06-.06a2 2 0 012.83 0 2 2 0 010 2.83l-.06.06a1.65 1.65 0 00-.33 1.82V9a1.65 1.65 0 001.51 1H21a2 2 0 012 2 2 2 0 01-2 2h-.09a1.65 1.65 0 00-1.51 1z"
          />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </router-link>
    </nav>
    <div
      v-if="$store.state.isLoading"
      class="z-10 fixed inset-0 flex justify-center items-center bg-white bg-opacity-50"
    >
      <spinner :color="'text-black'" :size="12" />
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner
  },
  data() {
    return {
      screenHeight: null
    };
  },
  async mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("orientationchange", this.handleResize);
  },
  methods: {
    handleResize: function() {
      this.screenHeight = window.innerHeight;
    }
  }
};
</script>

<style>
#router-view {
  padding-top: env(safe-area-inset-top, 0);
  padding-right: env(safe-area-inset-right, 0);
  padding-left: env(safe-area-inset-left, 0);
}

.nav-icon-selected {
  fill: #ffb81e48;
}
</style>